import { ActivatedRoute, Router, NavigationEnd, ActivationEnd } from "@angular/router";
import { environment } from "../../environments/environment";
import { AppLoadingStateService } from "../app-loading-state.service";
import { Injectable } from "@angular/core";
import { ApiUtils } from "./ApiUtils";
import { ConfDataService } from "../conf-data.service";

@Injectable()
export class AuthUtils {
    constructor(
        private router: Router,
        private apiUtils: ApiUtils,
        private appLoadingStateService: AppLoadingStateService,
        private confDataService: ConfDataService
    ) {
        this.router.events.subscribe((route) => {
            if (route instanceof ActivationEnd && route.snapshot.routeConfig.path === "authentication/:token" && environment.need_authentication) {
                this.getAuthToken(route);
            }
        });
    }

    getAuthToken(route) {
        const configToken = route.snapshot.params.token;
        this.apiUtils.loadDevisByConfigToken(configToken);
    }

    isAuthenticate() {
        let isAuthenticate = true;
        if (environment.need_authentication) {
            isAuthenticate = false;
            this.appLoadingStateService.leftColumnLoaded = true;
            this.appLoadingStateService.mainViewLoaded = true;
            this.appLoadingStateService.headerLoaded = true;
        }

        return isAuthenticate;
    }
}


// WEBPACK FOOTER //
// ./src/app/util/AuthUtils.ts